import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name : 'startCase'
})

export class StartCasePipe implements PipeTransform {

    transform(value) {
        // return value.replace(/ /g, '');
        return _.startCase(value);
    }

}



// WEBPACK FOOTER //
// ./client/app/shared/pipes/start-case.pipe.ts